// @ts-nocheck
import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Loadable from 'react-loadable';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';

import './App.scss';
import 'swiper/swiper.scss';

const loadableProps = {
  timeout: 60 * 1000,
};

const Loading = () => null;

const Index = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "home" */ '@/pages/Index'),
  loading: Loading,
});

const Wywk = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "home" */ '@/pages/Wywk'),
  loading: Loading,
});

const Pms = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "home" */ '@/pages/Pms'),
  loading: Loading,
});

const Cooperate = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "home" */ '@/pages/Cooperate'),
  loading: Loading,
});

const About = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "home" */ '@/pages/About'),
  loading: Loading,
});

const Supplier = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "home" */ '@/pages/Supplier'),
  loading: Loading,
});

const Policy = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "home" */ '@/pages/Policy'),
  loading: Loading,
});

const NotFound = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "notfound" */ '@/pages/NotFound'),
  loading: Loading,
});

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <Router basename="/en">
        <Switch>
          <Route exact path="/" component={Index} />
          <Route exact path="/wywk" component={Wywk} />
          <Route exact path="/pms" component={Pms} />
          <Route exact path="/cooperate" component={Cooperate} />
          <Route exact path="/about" component={About} />
          <Route exact path="/supplier" component={Supplier} />
          <Route exact path="/policy" component={Policy} />
          <Route component={NotFound} />
        </Switch>
      </Router>
    </ConfigProvider>
  );
}

export default App;
